/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 상태 토글 태그 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogInterestStatus.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { LoadPromoInterest } from './useSubmitPromoFilter'
import { usePromoDialogInterest } from 'src/stores/PromoStore'
import ToggleTagStatus from './ToggleTagStatus'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`
interface Props{
  result_id:number,
  school_class:string
}

const DialogInterestStatus = ({result_id,school_class}:Props) => {
    const syncField = usePromoDialogInterest((state)=>state.syncField)
    const resetField = usePromoDialogInterest((state)=>state.resetField)
    const handleSubmit = async () => {
        await syncField('status','base','temp')
        LoadPromoInterest(result_id,school_class)
    }
    const onClickReset = ()=>{
        resetField('temp_status')
    }
  return (
    <PageWrapper>
        <ToggleTagStatus/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogInterestStatus